module.exports = __webpack_public_path__ + "9cb6fa6048c83b3f722afbda0747bb09.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/kate-compton.jpg
// module id = 444
// module chunks = 0